import Vue from "vue";
import axios from "axios";
import common from "../common/common";
import myConfig from "../config/config";
import store from "../store/index";
import i18n from "@/config/i18n";
import { Modal, Notice } from "view-design";
// declare type Methods =
//   | "GET"
//   | "OPTIONS"
//   | "HEAD"
//   | "POST"
//   | "PUT"
//   | "DELETE"
//   | "TRACE"
//   | "CONNECT";
// declare interface Datas {
//   method?: Methods;
//   [key: string]: any;
// }
// axios.defaults.timeout = 2 * 60 * 1000;
if (axios.interceptors && axios.interceptors.request) {
    axios.interceptors.request.use((config) => {
        config.timeout = 2 * 60 * 1000;
        return config;
    }, (err) => {
        return Promise.reject(err);
    });
}
if (axios.interceptors && axios.interceptors.response) {
    axios.interceptors.response.use((response) => {
        return response;
    }, (err) => {
        if (err && err.response) {
            switch (err.response.status) {
                case 400:
                    err.msg = "请求错误(400)";
                    break;
                case 401:
                    err.msg = "未授权，请重新登录(401)";
                    break;
                case 403:
                    err.msg = "拒绝访问(403)";
                    break;
                case 404:
                    err.msg = "请求出错(404)";
                    break;
                case 408:
                    err.msg = "请求超时(408)";
                    break;
                case 500:
                    err.msg = "服务器错误(500)";
                    break;
                case 501:
                    err.msg = "服务未实现(501)";
                    break;
                case 502:
                    err.msg = "网络错误(502)";
                    break;
                case 503:
                    err.msg = "上传文件过大";
                    break;
                case 504:
                    err.msg = "请求服务超时";
                    break;
                case 505:
                    err.msg = "HTTP版本不受支持(505)";
                    break;
                default:
                    err.msg = `连接出错(${err.response.status})!`;
            }
            return Promise.reject(err.response.data);
        }
        else {
            err.message = "连接服务器失败!";
            err.status = "-1";
            return Promise.reject(err);
        }
    });
}
export const postHeaders = function (data) {
    const state = store.state; // eslint-disable-line
    const loginData = state.sys.userInfo;
    let headers = {
        "Content-Type": "application/json;charset=UTF-8",
        "Accept-Language": i18n.locale,
    };
    if (loginData && loginData.accessToken) {
        headers["access_token"] = loginData.accessToken;
        headers["Authorization"] = "Bearer " + loginData.accessToken;
    }
    if (data) {
        headers = Object.assign(headers, data);
    }
    return headers;
};
export const getAjaxData = function (url, params, configData) {
    if (url.indexOf("http") === -1 && url.indexOf(myConfig.ajaxHost) === -1) {
        const ajaxHost = myConfig.ajaxHost;
        url = ajaxHost + url;
    }
    let header = {};
    let method = "POST";
    if (configData) {
        if (configData.method === "get") {
            url = url + "?" + common.parseParam(params);
            params = {};
            method = "GET";
        }
        else if (configData.method === "postStr") {
            url = url + "?" + common.parseParam(params);
            params = {};
            method = "POST";
        }
        else if (configData.method === "getDel") {
            url = url + "?" + common.parseParam(params);
            params = {};
            method = "DELETE";
        }
        else if (configData.method === "delStr") {
            let srt = "";
            for (const i in params) {
                srt = srt + "/" + params[i];
            }
            url = url + srt;
            params = {};
            method = "DELETE";
        }
        else if (configData.method === "del") {
            method = "DELETE";
        }
        else if (configData.method === "formData") {
            // 这个是后面加的,所以看起来有点怪怪
            const paramsForm = new FormData(); // 创建表单
            for (const i in params) {
                paramsForm.append(i, params[i]); // eslint-disable-line
            }
            params = paramsForm;
            method = "POST";
            const formHeaders = configData.headers || {};
            formHeaders["Content-Type"] = "multipart/form-data";
            configData.headers = formHeaders;
        }
        if (configData.headers) {
            // headers 合并到请求头里面
            header = configData.headers;
        }
    }
    const headers = postHeaders(header);
    const options = {
        method: method,
        url: url,
        data: params,
        headers: headers,
    };
    if (configData && configData.timeout) {
        options.timeout = configData.timeout;
    }
    if (configData && configData.cancelToken) {
        const CancelToken = axios.CancelToken;
        options.cancelToken = new CancelToken(function executor(c) {
            Vue.prototype.$ajaxCancel = c;
            // 这个参数 c 就是CancelToken构造函数里面自带的取消请求的函数，这   里把该函数当参数用
        });
    }
    return options;
};
export const request = function (url, params, configData) {
    return new Promise((resolve, reject) => {
        const options = getAjaxData(url, params, configData);
        axios(options)
            .then(async (result) => {
            // 请求成功
            const successData = result.data;
            configData = configData || {};
            if (successData.status !== myConfig.apiStatus &&
                configData.noTips !== true) {
                // 默认弹出错误,如果传了  noTips 就不弹
                Notice.error({
                    title: i18n.t("tips"),
                    desc: successData.msg,
                });
            }
            resolve(successData);
        })
            .catch(async (error) => {
            // 请求异常
            reject(error);
            // 多次请求报错，只弹出一个框
            if (error.status === 401 || error.status === 4) {
                const text = error.code == 300022 ? error.msg : i18n.t("formText.loginTimeOut");
                Modal.confirm({
                    title: i18n.t("tips"),
                    content: text,
                    onOk: () => {
                        Vue.prototype.$common.out();
                    },
                });
            }
            else if (configData && configData.errorCallBack) {
                // 有错误回调
                configData.errorCallBack();
            }
            else {
                // 其它不是很严重的错误
                Modal.error({
                    title: i18n.t("tips"),
                    content: error.msg,
                });
            }
        });
    });
};
